import { createAPI } from '@common'
//
export default {
  // 读发布详情
  getRootArticlesPubDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qvcEfubjm', 'get', config),
  // 撤稿
  postArticlesRevoke: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0sfwplf', 'post', config),

  // 移动
  postRootArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0npwf', 'post', config),
  // 删除
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0efmfuf', 'post', config),
  // 读当前用户的所属部门文件夹列表，以及用户的缺省部门库(全媒体采编发的接口)
  postNewseditUsersFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0vtfst0gpmefst', 'get', config),
  // 将一到多篇稿件送到采编系统的部门库，并且把稿件的“当前处理人”设置为当前用户(全媒体采编发的接口)
  postNewseditArticlesSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0bsujdmft0tfmfdu', 'post', config),
  // 读当前用户有“可传入数据权限”的部门库内的文件夹列表(全媒体采编发的接口)
  getNewseditFolders: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0gpmefst', 'get', config),
  // 读一个文件夹下的所有用户列表(全媒体采编发的接口)
  getNewseditFoldersUsers: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0gpmefst0vtfst', 'get', config),
  // 指定一到多个文件夹，以及文件夹指定一到多个用户（可以不指定），把一到多篇稿件送入(全媒体采编发的接口)
  postNewseditArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0bsujdmft0usbotgfs',
      'post',
      config
    ),
  // 选用初始化
  getNewseditSelectInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0tfmfdu0joju', 'get', config),
  getForwardLogs: (config, vconfig) => {
    if (config.hubConfig) {
      return createAPI('customEncryptApiName-1/DNT;0nfejby.bsujdmfpsjhjo0sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        { hubForward: true, hub: 'e5/hub', ...vconfig }
      )
    } else {
      return createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0gpsxbse0mpht',
        'get',
        { params: config.params },
        vconfig
      )
    }
  },
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0usbotgfs', 'post', config),
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 获取有权限的
  getRootArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gpmefst', 'get', config),
  // 获取全部的
  getRootNormalArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60benjo0epn0gpmefst', 'get', config),
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qsppg', 'post', config),

  // 送稿-树
  getDeptSendTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0tfoe0usff',
      'get',
      config,
      vconfig
    ),
  // 选用文件夹树-部门树
  getDeptTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0bsujdmf0feju0ublf0usff',
      'get',
      config,
      vconfig
    ),
  // 选用-保存
  postArticleSelect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0tfmfdu', 'post', config),
  // 获取人员信息
  getUsersOfDept: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0vtfsgpmefs0vtfst', 'get', config, vconfig),
  // 送稿-保存
  postArticleSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0tfoe', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 流程记录
  getE5ActionsLogs: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60bdujpot0mpht', 'get', config, vconfig),
  // 提交审核-树
  getDeptFinalSendTree: (config, vconfig = { neverLoading: false }) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfbveju0bsujdmft0tfoe0usff',
      'get',
      config,
      vconfig
    ),
  // 上下线
  PostLive: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0mjwf', 'post', config)
}
